// extracted by mini-css-extract-plugin
export var chevronIcon = "_ae-2";
export var teamName = "_ae-1";
export var teamSwitcherButton = "_ae-0";